import { gql } from '@apollo/client';

export const GiftCardSummaryFragment = gql`
    fragment GiftCardSummaryFragment on Cart {
        id
        applied_gift_cards {
            code
            applied_balance {
                currency
                value
            }
        }
    }
`;
